module.exports = __webpack_public_path__ + "img/download-hover.d3133ffb.svg";